export default function TermsPage() {
  return (
    <article className="public-content public-policy">
      <p className="page-kicker">GovVue Light</p>
      <h1>Terms of Service</h1>
      <p className="public-policy__date">Effective September 24, 2026</p>

      <section>
        <h2>Acceptance and access</h2>
        <p>
          By using GovVue Light, you agree to these terms. The application is a private, invitation-only research tool. You must use only the account assigned to you and keep your sign-in credentials secure.
        </p>
      </section>

      <section>
        <h2>Permitted use</h2>
        <p>
          You may use GovVue Light to search and organize public federal contracting information for lawful research and business purposes. You may not attempt to bypass access controls, interfere with service operation, misuse third-party systems, or use the application unlawfully.
        </p>
      </section>

      <section>
        <h2>Third-party information</h2>
        <p>
          Contract opportunity and entity information is obtained from SAM.gov. SAM.gov remains the authoritative source. GovVue Light does not guarantee that third-party information is complete, current, or error-free, and users should confirm deadlines and requirements on the official SAM.gov record before acting.
        </p>
      </section>

      <section>
        <h2>No government affiliation</h2>
        <p>
          GovVue Light is independently operated and is not affiliated with, endorsed by, or operated by SAM.gov, the General Services Administration, or any other U.S. government agency.
        </p>
      </section>

      <section>
        <h2>Availability and changes</h2>
        <p>
          The application is provided on an “as available” basis and may be changed, suspended, or discontinued. Access may be disabled when necessary for security, maintenance, misuse, or administration.
        </p>
      </section>

      <section>
        <h2>Disclaimer and limitation</h2>
        <p>
          GovVue Light provides research assistance, not legal, procurement, or professional advice. To the extent permitted by law, the operator is not responsible for losses caused by reliance on third-party data, missed deadlines, service interruption, or unauthorized account use.
        </p>
      </section>

      <section>
        <h2>Privacy, updates, and contact</h2>
        <p>
          Use of the application is also governed by the Privacy Policy. These terms may be updated, with the effective date revised when changes are published. Questions can be sent to <a href="mailto:admin@govvue.com">admin@govvue.com</a>.
        </p>
      </section>
    </article>
  );
}
